import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="goods-select"
export default class extends Controller {
  static targets = ["selectInput", "countInput", "lengthInput", "widthInput", "heightInput", "weightInput", "optionTemplate", "stackableInput", "adrInput"];

  static values = {
    noResultsMessage: String,
  };

  connect() {
    const self = this;

    this.tomSelect = new TomSelect(this.selectInputTarget, {
      valueField: "value",
      searchField: ["text", "descriptiveText", "width", "height", "weight", "length"],
      plugins: ["dropdown_input"],
      onChange: function (value) {
        const isTube = value === "tube";
        const isDocuments = value === "documents";
        const goods = this.getItem(value)?.dataset || {};

        if (isTube) {
          self.stackableInputTarget.checked = false;
        }

        if (isDocuments) {
          self.stackableInputTarget.checked = false;
        }

        self.adrInputTarget.disabled = isDocuments;
        self.stackableInputTarget.disabled = isTube;

        self.countInputTarget.value = goods.count || "";
        self.lengthInputTarget.value = goods.length || "";
        self.widthInputTarget.value = goods.width || "";
        self.heightInputTarget.value = goods.height || "";
        self.weightInputTarget.value = goods.weight || "";

        self.element.dataset.shipmentItemLengthValue = goods.length || 0;
        self.element.dataset.shipmentItemWidthValue = goods.width || 0;
        self.element.dataset.shipmentItemHeightValue = goods.height || 0;

        // TODO: Convert this to a user preference in database.
        localStorage.setItem(
          "goodsSelection",
          JSON.stringify({
            value: value,
          })
        );
      },
      onInitialize: function () {
        if (!this.getValue()) {
          // Incase no default value is set, we check localStorage to set the previous selection
          const storedSelection = localStorage.getItem("goodsSelection");

          if (storedSelection) {
            const parsedSelection = JSON.parse(storedSelection);

            if (parsedSelection.value) {
              this.setValue(parsedSelection.value);
            }
          }
        }
      },
      render: {
        option: (data) => {
          return this.createOptionElement(data);
        },
        no_results: () => {
          return `<div class="no-results">${this.noResultsMessageValue}</div>`;
        },
        item: (data) => {
          return this.createOptionElement(data);
        },
      },
    });
  }

  createOptionElement(data) {
    const { text, descriptiveText, imageSrc, width, height, length, count, weight } = data;

    const optionTemplate = this.optionTemplateTarget.content.cloneNode(true);
    const optionElement = optionTemplate.querySelector(".goods--option");
    const imageElement = optionElement.querySelector(".goods--image");
    const textElement = optionElement.querySelector(".goods--title");
    const descElement = optionElement.querySelector(".goods--descriptive-text");

    imageElement.src = imageSrc;
    imageElement.alt = text;
    textElement.textContent = text;
    descElement.textContent = descriptiveText;
    optionElement.dataset.width = width || "";
    optionElement.dataset.height = height || "";
    optionElement.dataset.length = length || "";
    optionElement.dataset.count = count || "";
    optionElement.dataset.weight = weight || "";

    return optionElement;
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }
  }
}
